<template>
    <div class="container">
        <fixed-header>
            <div class="navbar">
                <mobileNav class="mob">

                </mobileNav>

                <nav class="nav">
                    <div class="logo"><img src="../assets/logo.svg" alt="" height="40"></div>
                    <div class="link-up">
                        <router-link :key="$route"  to="/about" >About</router-link>
                        <router-link to="/faq" href="">FAQs</router-link>
                        <a href="">Stories</a>
                        <a href="">Blog</a>
                        <a href="" style="color: #622586">Sign In</a>
                        <a href="" class="nav-button">Create Free Account</a>
                    </div>
                </nav>
            </div>
        </fixed-header>
        <div class="jumbo">

            <section class="hero">
                <div class="hero-text">
                    <h1>Risk-free <span>secure investment</span>  anywhere, anytime.</h1>
                    <p>The first-ever app that enables you to securely purchase and manage
                        Treasury Bills and Eurobonds from your mobile device.</p>
                    <a href="" class="hero-btn1">Create a Free Account</a> <br>
                    <div class="download-btn">
                        <a href="" class="hero-btn2"><img src="../assets/playstore.svg" alt="" height="30"></a>
                        <a href="" class="hero-btn3"><img src="../assets/appstore.svg" alt="" height="30"></a>
                    </div>

                </div>
                <div class="hero-image">

                    <img src="../assets/hero.png" alt="" height="600">
                </div>
            </section>
        </div>

        <body1></body1>
        <body2></body2>
        <body3></body3>
        <body4></body4>
        <body5></body5>
        <footer1></footer1>
        <footer2></footer2>

    </div>
</template>

<script>
    import body1 from '../components/home/body1.vue'
    import body2 from '../components/home/body2.vue'
    import body3 from '../components/home/body3.vue'
    import body4 from '../components/home/body4.vue'
    import body5 from '../components/home/body5.vue'
    import footer1 from '../components/home/footer1.vue'
    import footer2 from '../components/home/footer2.vue'
    import mobileNav from '../components/mobile-nav.vue'
    import FixedHeader from 'vue-fixed-header'


    export default {
        name: 'home',
        components: {
            body1,
            body2,
            body3,
            body4,
            body5,
            footer1,
            footer2,
            FixedHeader,
            mobileNav
        }
    }
</script>

<style scoped>

    .navbar.vue-fixed-header--isFixed {
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        filter: drop-shadow(0 5px 10px rgba(0,0,0,0.2));
        z-index: 1000;


    }
    .container {
        margin-top: 1rem;

    }

        .jumbo {
            height: 90vh;
            background: url('../assets/hero-bg.svg');
            background-repeat: no-repeat;
            padding: 2% 5%;
            background-position: 120% 50%;
            background-size: 25%;
        }

    .nav {
            display: flex;
            justify-content: space-between;
            padding: 1% 5% 1% 5%;
            background-color: #fff;
        }

        .hero div {
            width: 50%;
        }

        .hero-image  img {
            margin-top: -25px;
        }

        .hero-image {
            text-align: right;
            }

        .hero {
            display: flex;
            margin-top: 30px;
            flex-wrap: wrap;
        }
        .hero-text  p {
            max-width: 60ch;
            color: #8D8194;
            margin-bottom: 1rem;
            line-height: 1.5;
        }

        .hero-text   h1 {
                line-height: 1.3;
                font-size: 55px;
                margin-bottom: 0;
            }

        .hero-text  span {
             color: #8F5EAB;
         }

        .hero-btn1 {
                padding: 1.5rem 5rem;
                background-color: #FADE9D;
                color: #622586;
                text-decoration: none;
                font-weight: 600;
                border-radius: 3px;
                margin-top: 1rem;
                display: inline-block;
                font-size: 20px;
                transition: all 0.5s ease-in-out;
            }

            .hero-btn1:hover {
               outline: 1px solid #622586;
            }

        .hero-btn2 {
                display: inline-block;
                margin-top: 1rem;
                background-color: #311342;
                padding: 0.7rem 2rem 0.6rem 2rem;
                border-radius: 7px;
                margin-right: 1rem;
        }

    .hero-btn3 {
                display: inline-block;
                margin-top: 1rem;
                background-color: #311342;
                padding: 0.7rem 2rem 0.6rem 2rem;
                border-radius: 7px;
            }

    .hero > div > div{
                width: 100%;
                margin-top: 2rem;
            }


    .link-up  a {
        text-decoration: none;
        padding: 0 3%;
        color: #000;
        font-weight: 600;
            }

    .nav-button {
        border: 1px solid #622586;
        padding: 1rem 2rem;
        border-radius: 3px;
        color: #622586;
        font-weight: 600;
        background-color: #fff;
        transition: all 0.5s ease-in-out;
        display: inline-block;

    }

    .nav-button:hover {
        background-color: #622586;
        color: #fff !important;
    }

    .link-up {
            width: 70%;
            text-align: right;
        }

    /* Mobile responsive */

    @media screen and (max-width: 1100px) {
        .jumbo {
            height: 60vh;
        }
    }

    @media only screen and (max-width: 500px) {

        .nav {
            display: none;
        }

        .hero div {
            width: 100% ;

        }

        .hero-text h1 {
            font-size: 40px;
        }

        .hero-image {
            display: none;
        }
        .jumbo {
            height: 90vh;
        }

        .hero-btn3,.hero-btn2 {
            padding: 0.7rem 0rem 0.6rem 0rem;
            width: 48%;
            margin-right: 0;
            text-align: center;
        }

        .download-btn {
            display: flex;
            justify-content: space-between;
        }

        .hero-btn1 {
            display: block;
            text-align: center;
        }

    }


</style>